import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Col, Input, message, Popconfirm, Row } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import cmaApi from "../../../../api/cmaApi";
import CheckboxSlider from "../../../../components/SliderList/CheckboxSlider";
import TableWrap from "../../../../components/Table";
import TopContent from "../../../../components/TopContent";
import PageWrap from "../../../../layout/PageWrap";
import { appRoutes } from "../../../../routes/routes";
import { messages } from "../../../../utils/messages";

const CmaArticlesList = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(12);
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");

  const { data, isLoading, isFetching }: any = useQuery(
    ["cma_articles", currentPage, limit, search],
    () => cmaApi.getArticles(currentPage, limit, search || undefined)
  );

  const mutation = useMutation(cmaApi.deleteArticle, {
    onSuccess: (data: any) => {
      if (data.statusCode === 200) {
        message.success(messages.deleteSuccess);
        queryClient.invalidateQueries("cma_articles");
      } else {
        message.error(data?.data?.message ?? messages.error);
      }
    },
    onError: (err: any) => {
      message.error(err?.data?.message ?? messages.error);
    },
  });

  const mutationEdit = useMutation(cmaApi.editArticle, {
    onSuccess: (data: any) => {
      if (data.statusCode === 200) {
        message.success(messages.updateSuccess);
        queryClient.invalidateQueries("cma_articles");
      }
    },
    onError: () => {
      message.error(messages.error);
    },
  });

  const columns: ColumnsType<any> = [
    {
      title: "STT",
      align: "center",
      width: "3%",
      dataIndex: "index",
      key: "index",
    },
    {
      title: "Tên",
      width: "30%",
      dataIndex: "ten_vi",
      key: "ten_vi",
      render: (record: string, row: any) => (
        <a href={`${appRoutes.CMA.ARTICLES.LIST}/${row?._id}`}>{record}</a>
      ),
    },
    {
      title: "Hình ảnh",
      dataIndex: "photo",
      width: "20%",
      key: "photo",
      className: "td-slider-picture",
      render: (record: string) =>
        record ? (
          <img
            src={`${process.env.REACT_APP_DOMAIN}${record}`}
            alt=""
            className="slider-picture"
          />
        ) : null,
    },
    {
      title: "Lượt xem",
      dataIndex: "views",
      align: "center",
      width: "6%",
      key: "views",
      render: (record: number) => record ?? 0,
    },
    {
      title: "Nổi bật",
      dataIndex: "noibat",
      align: "center",
      width: "5%",
      key: "noibat",
      render: (record: boolean, row: any) => (
        <CheckboxSlider
          _id={row?._id}
          check={record}
          action={mutationEdit}
          formName="noibat"
        />
      ),
    },
    {
      title: "Hiển thị",
      dataIndex: "hienthi",
      align: "center",
      width: "5%",
      key: "hienthi",
      render: (record: boolean, row: any) => (
        <CheckboxSlider
          _id={row?._id}
          check={record}
          action={mutationEdit}
          formName="hienthi"
        />
      ),
    },
    {
      title: "Sửa",
      align: "center",
      width: "3%",
      render: (_, record: any) => (
        <EditOutlined
          onClick={() => {
            window.scrollTo(0, 0);
            navigate(`${appRoutes.CMA.ARTICLES.LIST}/${record?._id}`);
          }}
        />
      ),
    },
    {
      title: "Xóa",
      align: "center",
      width: "3%",
      render: (_, record: any) => (
        <Popconfirm
          title="Xác nhận xóa mục này"
          onConfirm={(e: any) => {
            e.preventDefault();
            mutation.mutate(record._id);
          }}
        >
          <DeleteOutlined style={{ color: "red" }} />
        </Popconfirm>
      ),
    },
  ];

  return (
    <PageWrap
      title="CMA · Bài viết"
      content={
        <div className="slider_list">
          <TopContent
            content={
              <Row>
                <Col>
                  <b>CMA · Bài viết</b>
                </Col>
                <Col>
                  <Button
                    onClick={() => navigate(appRoutes.CMA.ARTICLES.ADD)}
                  >
                    <PlusOutlined /> Add
                  </Button>
                </Col>
              </Row>
            }
          />
          <div className="content">
            <Row gutter={[10, 10]} style={{ marginBottom: 16 }}>
              <Col>
                <Input.Search
                  placeholder="Tìm kiếm"
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  onSearch={(v) => {
                    setSearch(v);
                    setCurrentPage(1);
                  }}
                  allowClear
                  style={{ width: 280 }}
                />
              </Col>
            </Row>
            <TableWrap
              loading={isLoading || isFetching}
              columns={columns}
              isShowTotal
              dataSource={data?.data?.source}
              rowKey="_id"
              bordered
              pagination={{
                pageSize: limit,
                current: currentPage,
                total: data?.data?.totalItems,
                onChange: (page: number, pageSize: number) => {
                  window.scrollTo(0, 0);
                  setCurrentPage(page);
                  setLimit(pageSize);
                },
              }}
              className="hover table-slide"
              hasDefaultColumn={false}
            />
          </div>
        </div>
      }
    />
  );
};

export default CmaArticlesList;
